<template>
    <v-layout justify-center>
        <v-dialog v-model="show" max-width="500px">
            <v-card>
                <v-card-title class="pa-0 ma-0">
                    <v-toolbar dark color="blue lighten-2" class="titlebar">
                        <v-btn icon dark @click="show = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>
                            Настройки подключения
                            <!--<v-spacer></v-spacer>-->
                            <v-progress-circular
                                    class="pl-3 ml-3"
                                    indeterminate
                                    color="default"
                                    v-if="loadSetting"
                            ></v-progress-circular>
                        </v-toolbar-title>

                    </v-toolbar>

                </v-card-title>
                <v-card-text class="content">
                    <v-container class="container-main" fluid>
                        <v-row>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-2">
                                <span>Настройки подключения</span>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-text-field
                                        label="Название подключения"
                                        v-model="VkGroupSetting.setting.title"
                                        class="ma-0 pa-0"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-text-field
                                        label="Адрес бота"
                                        v-model="VkGroupSetting.setting.url"
                                        class="ma-0 pa-0"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-text-field
                                        label="Статус подключения"
                                        v-model="VkGroupSetting.setting.status"
                                        class="ma-0 pa-0"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-2">
                                <span>Подписка бота на события</span>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.message_allow"
                                          inset
                                          label="Подписка на сообщения"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.message_deny"
                                          inset
                                          label="Отписка от сообщений"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.message_new"
                                          inset
                                          label="Новые сообщения"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.message_reply"
                                          inset
                                          label="Отправленные сообщения"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.group_join"
                                          inset
                                          label="Подписка на группу"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.group_leave"
                                          inset
                                          label="Отписка от группы"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.wall_post_new"
                                          inset
                                          label="Новый пост на стене"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                            <v-col cols="12" xs12 class="ma-0 px-3 py-0">
                                <v-switch v-model="VkGroupSetting.events.wall_reply_new"
                                          inset
                                          label="Добавление комментария на стене"
                                          color="primary"
                                          :false-value="0"
                                          :true-value="1"
                                ></v-switch>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-spacer></v-spacer>
                                <v-btn
                                        text
                                        @click="saveSetting()"
                                >Сохранить</v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-model="snackbar"
                bottom
                :color="paramsSnackbar.color"
                right
        >
            {{paramsSnackbar.text}}
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Закрыть
            </v-btn>
        </v-snackbar>
    </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    name: 'SettingGroupVkDialog',
    data() {
        return {
            paramsSnackbar: {
                color: 'success',
                text: 'Успешно сохранено!'
            },
            snackbar: false,
            VkGroupSetting: {
                setting: {
                    id: null,
                    title: '',
                    url: '',
                    status: ''
                },
                events: {
                    message_allow: 0,
                    message_deny: 0,
                    message_new: 0,
                    message_reply: 0,
                    group_join: 0,
                    group_leave: 0,
                    wall_post_new: 0,
                    wall_reply_new: 0
                }
            },
            loadSetting: true
        }
    },
    props: ['dialog', 'botId'],
    methods: {
        saveSetting() {
            axios.defaults.withCredentials = true
            axios.post(
                constConf.bot.url + '/bot/set-vk-group-setting/' + this.botId,
                Object.assign({}, this.VkGroupSetting)
            )
                .then((response) => {
                    console.log(response.data)
                    if (response.data.hasOwnProperty('success')) {
                        this.paramsSnackbar.color = 'success'
                        this.paramsSnackbar.text = 'Настройки успешно сохранены!'
                    } else {
                        this.paramsSnackbar.color = 'error'
                        this.paramsSnackbar.text = 'Не удалось сохранить настройки.. Повторите попытку'
                    }
                    this.snackbar = true
                })
                .catch((error) => {
                    console.log('Ошибка при группы')
                    console.log(error)
                })
        }
    },
    computed: {
        ...mapGetters({
            vkGroups: 'user/getVkGroups',
            loadedVkGroups: 'user/loadedVkGroups'
        }),
        show: {
            get() {
                return this.dialog
            },
            set(value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        }
    },
    watch: {
        dialog(value) {
            if (value) {
                this.loadSetting = true
                axios.defaults.withCredentials = true
                axios.get(
                    constConf.bot.url + '/bot/get-vk-group-setting/' + this.botId
                )
                    .then((response) => {
                        console.log(response.data)
                        if (response.data.hasOwnProperty('success')) {
                            this.VkGroupSetting.setting = response.data.success.setting
                            this.VkGroupSetting.events = response.data.success.events
                        }
                        this.loadSetting = false
                    })
                    .catch((error) => {
                        console.log('Ошибка при группы')
                        console.log(error)
                    })
            }
        }
    }
}
</script>

<style scoped>
    .container-main {
        width: 100vw;
        height: 70vh;
        display: flex;
        flex-direction: column;
    }
    .content {
        flex-grow: 1;
        overflow-x: auto;
    }
</style>
